import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-5 w-5 rounded-full" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-white",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-gray-100",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSelection && _ctx.changeSelection(...args))),
      disabled: _ctx.disabled,
      class: _normalizeClass(["h-full w-full rounded-full disabled:opacity-25 disabled:cursor-not-allowed", {
        'bg-primary': _ctx.selected,
        'bg-gray-100': !_ctx.selected,
      }])
    }, [
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
    ], 10, _hoisted_2)
  ]))
}